"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmation = exports.ConfirmationProvider = void 0;
const React = require("react");
const react_1 = require("react");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../structure/Modal");
const FlatButton_1 = require("./FlatButton");
const ConfirmationContext = (0, react_1.createContext)(undefined);
const ConfirmationProvider = ({ children }) => {
    const [state, setState] = (0, react_1.useState)(null);
    const showConfirmation = (options) => {
        return new Promise(resolve => {
            setState(Object.assign(Object.assign({}, options), { resolver: resolve }));
        });
    };
    const handleConfirm = () => {
        if (state === null || state === void 0 ? void 0 : state.resolver) {
            state.resolver(true);
            setState(null);
        }
    };
    const handleCancel = () => {
        if (state === null || state === void 0 ? void 0 : state.resolver) {
            state.resolver(false);
            setState(null);
        }
    };
    return (React.createElement(ConfirmationContext.Provider, { value: { showConfirmation } },
        children,
        state && (React.createElement(Modal_1.Modal, { open: true, onClose: handleCancel, size: dialogs_1.TDialogSizes.Medium, appMode: false },
            React.createElement(Modal_1.ModalHeader, null, state.title),
            React.createElement(Modal_1.ModalBody, null,
                React.createElement("div", { style: { display: "flex", flexDirection: "column", padding: 20 } },
                    React.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: 50
                        } }, state.message),
                    React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, state.ShowButtons ? (React.createElement(React.Fragment, null,
                        React.createElement(FlatButton_1.default, { onClick: handleConfirm, style: { background: "green", flex: 1, marginRight: 5 } }, "Yes"),
                        React.createElement(FlatButton_1.default, { onClick: handleCancel, style: { background: "grey", flex: 1, marginLeft: 5 } }, "No"))) : (React.createElement(FlatButton_1.default, { onClick: handleConfirm, style: { background: "green", flex: 1, marginRight: 5 } }, "Continue")))))))));
};
exports.ConfirmationProvider = ConfirmationProvider;
const useConfirmation = () => {
    const context = (0, react_1.useContext)(ConfirmationContext);
    if (!context) {
        throw new Error("useConfirmation must be used within a ConfirmationProvider");
    }
    return context.showConfirmation;
};
exports.useConfirmation = useConfirmation;
//# sourceMappingURL=ConfirmationDialog.js.map